import React from 'react';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative w-full bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 text-white overflow-hidden" data-id="element-147">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-148">
        <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
        backgroundSize: '40px 40px'
      }} data-id="element-149" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32" data-id="element-150">
        <div className="text-center max-w-4xl mx-auto" data-id="element-151">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight" data-id="element-152">
            Tu tienda global, más cerca de tu familia
          </h1>
          <p className="text-xl md:text-2xl mb-10 text-blue-100 leading-relaxed" data-id="element-153">
            Compra, envía y ahora alimenta a los tuyos en Cuba
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-154">
            <Button variant="primary" className="text-lg px-8 py-4" data-id="element-155">
              Ver combos de comida
            </Button>
            <Button variant="secondary" className="text-lg px-8 py-4" data-id="element-156">
              Comprar ahora
            </Button>
          </div>
        </div>
      </div>

      {/* Bottom Wave */}
      <div className="absolute bottom-0 left-0 right-0" data-id="element-157">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" data-id="element-158">
          <path d="M0 0L60 10C120 20 240 40 360 46.7C480 53 600 47 720 43.3C840 40 960 40 1080 46.7C1200 53 1320 67 1380 73.3L1440 80V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0V0Z" fill="white" data-id="element-159" />
        </svg>
      </div>
    </section>;
}